export default "__VITE_ASSET__CkT6KNaI__"